import type { ReactNode } from 'react'

import { cn } from '@/_lib/utils'

const ZJobsEyebrow = ({ children, className }: { children: ReactNode; className?: string }) => {
	return (
		<p className={cn('uppercase text-sm md:text-base mb-2 lg:mb-3 font-light', className)}>
			{children}
		</p>
	)
}

export default ZJobsEyebrow
